// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import { UNCAUGHT_ERROR } from 'errors'

const errWrap = {
  border: '1px solid',
  width: 500,
}

const stackStyles = {
  maxHeight: '20vh',
  overflow: 'auto',
  whitespace: 'pre',
}

class GlobalErrorBoundary extends React.Component {
  static propTypes = {
    children: object.isRequired,
  }

  state = {
    hasError: false,
    message: null,
    stack: null,
  }

  componentDidCatch (error, info) {
    const message = error.message || UNCAUGHT_ERROR
    const stack = info.componentStack

    this.setState({
      hasError: true,
      message,
      stack,
    })
  }

  render () {
    const {
      hasError,
      message,
      stack,
    } = this.state

    if (hasError) {
      return (
        <div className={'padding-1 display-flex align-items-center'}>
          <div
            className={'border-radius-2 padding-1 margin-1 display-flex flex-direction-column'}
            style={errWrap}>
            <h1>{'Something went wrong.'}</h1>
            <p>{`The application crashed with the following message:`}</p>
            <p className={'error-message padding-top-1 padding-bottom-1'}>
              {message}
            </p>
            <details>
              <summary>{'Component Stack Trace'}</summary>
              <pre style={stackStyles}>{stack}</pre>
            </details>
            <button
              className={'btn btm-md bg-blue hover-inverse heading-font margin-left-auto'}
              href={'#'}
              onClick={e => { location.reload() }}>
              {'Reload Page'}
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default GlobalErrorBoundary
